// extracted by mini-css-extract-plugin
export default {"main":"BaseSimpleItemEditorFooter_main__alCjl","buttonsArea":"BaseSimpleItemEditorFooter_buttonsArea__oWdk-"};